import { createOpenAPIClient } from "@marcuslongmuir/openapi-typescript-helpers";
import { adminServiceSchema } from "@teamtable/api";

export const apiClient = createOpenAPIClient(adminServiceSchema, {
  baseUrl: window.serverConfig?.API_URL || window.location.origin,
  fetchOverride: (request: Request) => {
    return fetch(request, { credentials: "include" });
  },
});
